<template>
    <v-sheet>
      <v-row>
        <v-col cols="8" class="text-center">
          <v-row>
            <v-col cols="12" class="pt-0">
              <v-select
                :items="options"
                v-model="selectedOption"
                item-text="label"
                return-object
                label="Amount of offers grouped"
              ></v-select>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-row>
                <v-col cols="6" class="justify-center d-inline-flex ">
                  <increase-decrease-tooltip
                    :current-value="counters.allOffersCurrent"
                    :previous-value="counters.allOffersOneAgo"
                    :current-label="comparisonCurrent.start"
                    :previous-label="comparisonCurrent.end"
                    v-if="counters.allOffersCurrent > 0"
                  ></increase-decrease-tooltip>
                  <h4 class="align-self-center" v-else>No data available yet</h4>
                </v-col>
                <v-col cols="6" class="d-inline-flex justify-center">
                  <increase-decrease-tooltip
                    :current-value="counters.allOffersOneAgo"
                    :previous-value="counters.allOffersTwoAgo"
                    :current-label="comparisonPrevious.start"
                    :previous-label="comparisonPrevious.end"
                  ></increase-decrease-tooltip>
                </v-col>
                <v-col cols="6" class="d-inline-flex justify-center">
                  <span class="">Comparing 1 vs 2 weeks ago</span>
                </v-col>
                <v-col cols="6" class="d-inline-flex justify-center">
                  <span class="">Comparing 2 vs 3 weeks ago</span>
                </v-col>
              </v-row>
            </v-col>

          </v-row>
        </v-col>
        <v-col cols="4" class="text-center">
          <h3 class="display-1 text-center">New offers</h3>
          <v-row>
            <v-col cols="6" class="d-inline-flex justify-center">
              <h3 class="display-3" v-if="newOffersCurrentWeek > 0">{{newOffersCurrentWeek}}</h3>
              <h4 class="align-self-center" v-else>No data available yet</h4>
            </v-col>
            <v-col cols="6">
              <h3 class="display-3">{{newOffersLastWeek}}</h3>
            </v-col>
            <v-col cols="6">
              <span class="">Last week (w{{currentWeekNumber-1}})</span>
            </v-col>
            <v-col cols="6">
              <span class="">Two weeks ago (w{{previousWeekNumber-1}})</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

    </v-sheet>
</template>

<script>
    import IncreaseDecreaseTooltip from "../../Widgets/increaseDecreaseTooltip";
    export default {
      name: "JobOffersCounters",
      components: {IncreaseDecreaseTooltip},
      props: {
        jobOffersCounters: {
          type: Object
        }
      },
      data(){
        return {
          options: [
            { label: 'Weekly', value: 'weekly'},
            { label: 'Monthly', value: 'monthly'}
          ],
          selectedOption:  { label: 'Weekly', value: 'weekly'}
        }
      },
      computed: {
        counters() {
          return this.jobOffersCounters && this.jobOffersCounters.counters ? this.jobOffersCounters.counters[this.selectedOption.value] : {}
        },
        newOffersCurrentWeek() {
          return this.jobOffersCounters && this.jobOffersCounters.counters && this.jobOffersCounters.counters.weekly.newOffersCurrent
        },
        newOffersLastWeek() {
          return this.jobOffersCounters && this.jobOffersCounters.counters && this.jobOffersCounters.counters.weekly.newOffersLast
        },
        currentWeekNumber() {
          return this.jobOffersCounters && this.jobOffersCounters.dateReference && this.jobOffersCounters.dateReference.weekly.current.weekOfYear
        },
        previousWeekNumber(){
          return this.jobOffersCounters && this.jobOffersCounters.dateReference && this.jobOffersCounters.dateReference.weekly.oneAgo.weekOfYear
        },
        comparisonCurrent() {
          const period = {start: undefined, end: undefined}
          if (this.jobOffersCounters && this.jobOffersCounters.dateReference) {
            if (this.selectedOption.value === 'weekly') {
              period.start = `week ${this.jobOffersCounters.dateReference.weekly.current.weekOfYear}`
              period.end = `week ${this.jobOffersCounters.dateReference.weekly.oneAgo.weekOfYear}`
            }
            else if (this.selectedOption.value === 'monthly') {
              period.start = (new Date(null, this.jobOffersCounters.dateReference.monthly.current.month)).toLocaleString('en-US', {month: 'long'})
              period.end = (new Date(null, this.jobOffersCounters.dateReference.monthly.oneAgo.month)).toLocaleString('en-US', {month: 'long'})
            }
          }
          return period
        },
        comparisonPrevious() {
          const period = {start: undefined, end: undefined}
          if (this.jobOffersCounters && this.jobOffersCounters.dateReference) {
            if (this.selectedOption.value === 'weekly') {
              period.start = `week ${this.jobOffersCounters.dateReference.weekly.oneAgo.weekOfYear}`
              period.end = `week ${this.jobOffersCounters.dateReference.weekly.twoAgo.weekOfYear}`
            }
            else if (this.selectedOption.value === 'monthly') {
              period.start = (new Date(null, this.jobOffersCounters.dateReference.monthly.oneAgo.month)).toLocaleString('en-US', {month: 'long'})
              period.end = (new Date(null, this.jobOffersCounters.dateReference.monthly.twoAgo.month)).toLocaleString('en-US', {month: 'long'})
            }
          }
          return period
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Charts/Profile/JobOffersCounters.vue